import Base from "../base";

/** お試し条件オプション */
export interface AiReportExperimentConditionOption {
  /** 報告月(YYYY-MM) */
  yearmonth: string;
  /** 1:プロンプトに「本日の状態（バイタル）」を含める */
  use_vital: number;
  /** 1:プロンプトに「観察項目」を含める */
  use_observation: number;
  /** 1:プロンプトに「最新の看護記録I（提出済み）に記載された家族情報」を含める */
  use_vn_record_fam: number;
}

export const DefaultAiReportExperimentConditionOption =
  (): AiReportExperimentConditionOption => ({
    yearmonth: "",
    use_vital: 0,
    use_observation: 0,
    use_vn_record_fam: 0,
  });

/** お試し条件 */
export interface AiReportExperimentCondition extends Base {
  /** ID */
  id: number;
  /** 種別 1:看護計画書 2:月次報告書 */
  type: number;
  /** 契約ID */
  agreement_id: number;
  /** 事業所ID */
  office_id: number;
  /** 利用者ID */
  patient_id: number;
  /** 企業コード */
  co_code: string;
  /** 法人名 */
  co_name: string;
  /** 事業所コード */
  kst_no: string;
  /** 事業所名 */
  office_name: string;
  /** 利用者氏名 */
  patient_name: string;
  /** コメント */
  comment: string;
  /** 登録者(管理ユーザー)ID */
  editor_admin_id: number;
  /** オプション(SON形式で保存) */
  option: AiReportExperimentConditionOption;
}

export const DefaultAiReportExperimentCondition =
  (): AiReportExperimentCondition => ({
    id: 0,
    type: 0,
    agreement_id: 0,
    office_id: 0,
    patient_id: 0,
    co_code: "",
    co_name: "",
    kst_no: "",
    office_name: "",
    patient_name: "",
    comment: "",
    editor_admin_id: 0,
    created_at: "",
    updated_at: "",
    deleted_at: "",
    option: DefaultAiReportExperimentConditionOption(),
  });
